import { MarketingNav, MarketingFooter } from "@/components/marketing/MarketingChrome";

export function MarketingPage({ eyebrow, title, lead, banner, children }) {
  return (
    <div className="min-h-screen bg-white">
      <MarketingNav />
      <section className="brand-hero relative overflow-hidden pt-28 pb-14 text-white">
        {banner ? (
          <>
            <img src={banner} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#00243f]/95 via-[#00243f]/80 to-[#003057]/55" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#00243f]/90 via-transparent to-[#00243f]/40" />
          </>
        ) : (
          <div className="brand-mesh absolute inset-0" />
        )}
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#a8e063]">{eyebrow}</p>}
          <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight drop-shadow-sm sm:text-5xl">{title}</h1>
          {lead && <p className="mt-4 max-w-3xl text-lg leading-relaxed text-slate-200">{lead}</p>}
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-4 py-14 sm:px-6 lg:px-8">{children}</section>
      <MarketingFooter />
    </div>
  );
}
